import {useEffect} from 'react'
import {useDispatch} from 'react-redux'
import {setIsUpdateAccount, useMessagesIsUpdateAccount, useOpenDialog} from 'entities/messages'
import {setPackageModalOpen, useWallet} from 'entities/payment'
import {PRICE} from 'shared/lib'
import {Button} from 'shared/ui/buttons'
import styles from './styles.module.scss'

export const ChatUpgradeAccount = () => {
  const dispatch = useDispatch()
  const openDialog = useOpenDialog()
  const wallet = useWallet()
  const isUpdateAccount = useMessagesIsUpdateAccount()

  const clickHandler = () => {
    dispatch(setPackageModalOpen(true))
  }

  useEffect(() => {
    if (wallet.credits + wallet.freeCredits >= PRICE.CHAT) {
      dispatch(setIsUpdateAccount(false))
    }
  }, [wallet.credits, wallet.freeCredits])

  if (!isUpdateAccount) return <></>

  return (
    <div className={styles.root}>
      <div className={styles.text}>
        Your balance is {wallet.credits + wallet.freeCredits} GoCoins. To chat with
        <span className={styles.textName}> {openDialog?.interlocutor.name} </span>
        please upgrade account
      </div>

      <Button styleType='secondary' className={styles.buttonUpgradeAccount} onClick={clickHandler}>
        <span className={styles.buttonUpgradeAccountText}>Upgrade account</span>
      </Button>
    </div>
  )
}